"use client";

import { Menu, X } from "lucide-react";
import Link from "next/link";
import { useState } from "react";
import { Logo } from "@/components/ui/Logo";

export function LandingHeader() {
  const [isOpen, setIsOpen] = useState(false);

  // «Características» y «Tipos de DTE» apuntaban a anclas del home (`/#caracteristicas`,
  // `/#dtes`). Las páginas reales —`/caracteristicas` y las once de tipos de DTE— estaban en el
  // sitemap y **no las enlazaba ninguna página del sitio**: solo llegaba quien tecleara la URL.
  // Google descubre y pondera por enlaces, así que una página que nadie enlaza pesa cero por más
  // que esté en el sitemap. El menú es el enlace que aparece en todas las páginas.
  const menuItems = [
    { label: "Características", href: "/caracteristicas" },
    { label: "Tipos de DTE", href: "/que-es-dte" },
    // La API existia y no se alcanzaba desde ninguna parte del sitio publico: solo la
    // encontraba quien ya sabia la URL. Se etiqueta «API» y no «Desarrolladores» porque es la
    // palabra que busca con los ojos un jefe de TI evaluando la integracion.
    { label: "API", href: "/desarrolladores" },
    { label: "Contacto", href: "/#contacto" },
  ];

  return (
    <nav className="fixed z-50 w-full border-b border-slate-200/60 bg-white/90 backdrop-blur-[10px] transition-all duration-300 dark:border-slate-800 dark:bg-slate-950/90">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-20 items-center justify-between">
          <div className="flex shrink-0 items-center">
            <Link href="/" onClick={() => setIsOpen(false)}>
              <Logo size="md" className="origin-left scale-90 md:scale-100" />
            </Link>
          </div>

          <div className="hidden items-center space-x-8 md:flex">
            {menuItems.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                className="font-medium text-slate-600 transition hover:text-[#1E3A8A] dark:text-slate-300 dark:hover:text-blue-300"
              >
                {item.label}
              </Link>
            ))}
            <Link href="/login" className="font-bold text-[#1E3A8A] hover:underline dark:text-blue-300">
              Iniciar sesión
            </Link>
            <Link
              href="/register"
              className="rounded-lg bg-[#1E3A8A] px-5 py-2.5 font-bold text-white shadow-lg transition hover:bg-blue-800 hover:shadow-blue-900/30"
            >
              Comenzar ahora
            </Link>
          </div>

          <div className="flex items-center md:hidden">
            <button
              onClick={() => setIsOpen((value) => !value)}
              className="p-2 text-slate-600 hover:text-slate-900 focus:outline-none dark:text-slate-300 dark:hover:text-white"
              aria-label="Abrir menú"
            >
              {isOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="absolute left-0 top-20 flex w-full flex-col space-y-4 border-b border-slate-200 bg-white px-4 py-4 shadow-xl animate-in slide-in-from-top-5 duration-200 dark:border-slate-800 dark:bg-slate-950 md:hidden">
          {menuItems.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              onClick={() => setIsOpen(false)}
              className="border-b border-slate-100 py-2 text-lg font-medium text-slate-600 hover:text-[#1E3A8A] last:border-0 dark:border-slate-800 dark:text-slate-300 dark:hover:text-blue-300"
            >
              {item.label}
            </Link>
          ))}
          <div className="flex flex-col gap-3 pt-2">
            <Link
              href="/login"
              onClick={() => setIsOpen(false)}
              className="py-2 text-center font-bold text-[#1E3A8A] hover:underline dark:text-blue-300"
            >
              Iniciar sesión
            </Link>
            <Link
              href="/register"
              onClick={() => setIsOpen(false)}
              className="rounded-xl bg-[#1E3A8A] px-5 py-3 text-center font-bold text-white shadow-lg transition hover:bg-blue-800"
            >
              Comenzar ahora
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
